<template>
  <el-dialog
      :model-value="modelValue"
      title="Yilni nusxalash"
      width="560px"
      align-center
      destroy-on-close
      @update:model-value="$emit('update:modelValue', $event)"
  >
    <p class="fc-toolbar__hint fc-copy-intro">
      Manba yilning barcha hodisalari maqsad yilga ko'chiriladi — qator, davriylik,
      kun, diapazon va matnlari bilan.
    </p>

    <el-form ref="formRef" :model="form" label-position="top">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="Manba yil">
            <el-select v-model="form.from_year" filterable style="width: 100%">
              <el-option v-for="y in years" :key="y" :label="y" :value="y"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Maqsad yil">
            <el-input-number
                v-model="form.to_year"
                :min="yearMin"
                :max="yearMax"
                controls-position="right"
                style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-alert v-if="sameYear" type="error" :closable="false" show-icon>
        Manba va maqsad yili bir xil bo'lmasligi kerak.
      </el-alert>

      <div class="fc-notes">
        <p>
          <b>Mavjud kataklar tegilmaydi.</b> Maqsad yilda allaqachon bor hodisa ustidan
          yozilmaydi — shuning uchun ikki marta yuborsangiz ikkinchisida hech narsa ko'chmaydi.
        </p>
        <p>
          <b>Hisobot davri matnlari o'zgarmasdan ko'chadi.</b> 2026-dan nusxalasangiz,
          2027-yilda ham «2025 yil uchun» yozuvi turadi. Shuning uchun nusxalagandan keyin
          har qator uchun generatorni <b>«Eskisini o'chirib, noldan yozish»</b> rejimida
          qayta yurgizing.
        </p>
      </div>
    </el-form>

    <template #footer>
      <el-button plain :disabled="submitting" @click="$emit('update:modelValue', false)">
        Bekor qilish
      </el-button>
      <el-button type="primary" :loading="submitting" :disabled="sameYear" @click="onSubmit">
        Nusxalash
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessageBox, ElNotification } from "element-plus";
import api, { apiErrorMessage, YEAR_MIN, YEAR_MAX } from "./financeCalendarApi";

export default {
  name: "CopyYearDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    // Ma'lumot bor yillar (admin endpointidan) — manba sifatida tanlanadi.
    years: { type: Array, default: () => [] },
    year: { type: Number, default: null },
  },
  emits: ["update:modelValue", "done", "open-generator"],
  data() {
    return {
      submitting: false,
      yearMin: YEAR_MIN,
      yearMax: YEAR_MAX,
      form: this.buildForm(),
    };
  },
  computed: {
    sameYear() {
      return !!this.form.from_year && this.form.from_year === this.form.to_year;
    },
  },
  watch: {
    modelValue(val) {
      if (!val) return;
      this.form = this.buildForm();
    },
  },
  methods: {
    buildForm() {
      const from = this.year || this.years[0] || new Date().getFullYear();
      return { from_year: from, to_year: from + 1 };
    },
    onSubmit() {
      this.submitting = true;
      api
          .copyYear({ from_year: Number(this.form.from_year), to_year: Number(this.form.to_year) })
          .then((result) => {
            const copied = result?.copied ?? 0;
            this.$emit("update:modelValue", false);
            this.$emit("done", result);
            if (!copied) {
              ElNotification.info({
                title: "Hech narsa ko'chmadi",
                message: `${this.form.to_year}-yilda bu kataklar allaqachon bor yoki ${this.form.from_year}-yilda hodisa yo'q.`,
                duration: 7000,
              });
              return;
            }
            this.confirmRegenerate(copied);
          })
          .catch((error) => {
            ElNotification.error({
              title: "Nusxalab bo'lmadi",
              message: apiErrorMessage(error),
            });
          })
          .finally(() => {
            this.submitting = false;
          });
    },
    // Nusxalangan hodisalarda eski yilning hisobot davri matni turadi —
    // adminni darhol generatorga yo'naltiramiz (CONSOLE.md §8, §9).
    confirmRegenerate(copied) {
      const toYear = Number(this.form.to_year);
      ElMessageBox.confirm(
          `${copied} ta hodisa ${toYear}-yilga ko'chirildi. Ularda hozircha ${this.form.from_year}-yilning hisobot davri matni turibdi. Generatorni ochib, matnlarni yangilaysizmi?`,
          "Nusxalash tugadi",
          {
            confirmButtonText: "Generatorni ochish",
            cancelButtonText: "Keyinroq",
            type: "success",
          }
      )
          .then(() => this.$emit("open-generator", toYear))
          .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
@use "./finance-calendar.scss";

.fc-copy-intro {
  margin: 0 0 16px;
}

.fc-notes {
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  background: #fafbfd;
  font-size: 12px;
  line-height: 1.6;
  color: #6b7485;

  p {
    margin: 0 0 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
